export default __webpack_public_path__ + "static/media/m1.b3adcc91.svg";